type EvaluateFn = (expr: string) => number;

let mathjsPromise: Promise<EvaluateFn> | null = null;

export function preloadMathjs(): Promise<EvaluateFn> {
    mathjsPromise ??= import("mathjs")
        .then((m) => m.evaluate)
        .catch((error) => {
            mathjsPromise = null;
            throw error;
        });
    return mathjsPromise;
}

export function getEvaluate(): Promise<EvaluateFn> {
    return preloadMathjs();
}
